/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Not_PurchasedInputs */

const cs_enum_not_purchased = /** @type {(inputs: Enum_Not_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nekoupil`)
};

const en_enum_not_purchased = /** @type {(inputs: Enum_Not_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not purchased`)
};

/**
* | output |
* | --- |
* | "Not purchased" |
*
* @param {Enum_Not_PurchasedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_not_purchased = /** @type {((inputs?: Enum_Not_PurchasedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Not_PurchasedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_not_purchased(inputs)
	return cs_enum_not_purchased(inputs)
});